import { combineReducers } from "redux";
import app from "./app/reducer";
import auth from "./auth/reducer";
import booking from "./booking/reducer";
import chat from "./chat/reducer";
import search from "./search/reducer";
import user from "./user/reducer";
import venue from "./venue/reducer";

const rootReducer = {
  app,
  user,
  venue,
  search,
  auth,
  chat,
  booking
};

const combinedReducer = combineReducers(rootReducer);

export type RootState = ReturnType<typeof combinedReducer>;

export default rootReducer;
